import styled from 'styled-components';

export const GlobalAccessStyled = styled.div<{
  globalAccess: boolean;
  disabled: boolean;
}>`
  display: flex;
  padding: 30px 20px;
  border: 1px solid
    ${(props) =>
      props.disabled
        ? props.theme.atlas.semantic.color.outline.disabled
        : props.globalAccess
          ? props.theme.atlas.semantic.color.action.primary.hover
          : props.theme.atlas.semantic.color.outline.default};

  background-color: ${(props) =>
    props.disabled
      ? props.theme.atlas.semantic.color.surface.variant
      : props.globalAccess
        ? props.theme.atlas.semantic.color.surface.variant
        : props.theme.atlas.semantic.color.surface.default};
  border-radius: 4px;
`;

export const GlobalAccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 20px;
`;
